<template>
  <div
    class="signup"
    id="content"
    style="position: absolute;height: 100%;background: #f3f3f3;"
    v-wechat-title="$route.meta.title"
  >
    <div class="bannerSignup">
      <img :src="url" alt class />
      <img v-if="!url" src="../../assets/images/bmBg.jpg" />
    </div>
    <div class="inputBox">
      <van-button
        block
        round
        color="linear-gradient(to right, #1cd65a, #00cc74)"
        @click="go('signupSearch')"
      >
        查看报名状态
      </van-button>
      <p class="fontSizeDiv">如果已报名，点击按钮即可查看报名状态</p>
      <div class="inputCont">
        <ul>
          <li :class="{ 'active s1': type === '1' }" @click="typeNav('1')">
            在线报名
          </li>
          <li :class="{ 'active s2': type === '2' }" @click="typeNav('2')">
            报名须知
          </li>
        </ul>
        <div class="inputkuang" v-show="type == '1'">
          <div  v-show="!showFlase">
            <p class="fontSizeDiv">
              <i><van-icon name="warning-o"/></i>注：带
              <span style="color:red">*</span> 的所填项为必填项
            </p>
            <template v-for="item in settingDetail">
              <template v-if="item.display && item.fieldCaption != null">
                <dl
                  :class="{
                    chbox:
                      item.editorType == 2 ||
                      item.editorType == 5 ||
                      item.editorType == 4,
                  }"
                  :key="item.id"
                >
                  <dt :class="{ fieldLabelRequired: !item.nullable }">
                    {{ item.fieldCaption }} <sup v-if="item.nullable == 0">*</sup>
                  </dt>
                  <dd v-if="item.editorType == 1">
                    <!-- 单行文本框 -->
                    <van-field
                      class="input-item"
                      v-model="formData[item.field]"
                      :maxlength="item.fieldLength"
                      clearable
                      :placeholder="'请输入' + item.fieldCaption"
                    />
                  </dd>
                  <dd v-if="item.editorType == 7">
                    <van-field
                      class="input-item"
                      v-model="formData[item.field]"
                      :maxlength="item.fieldLength"
                      type="textarea"
                      clearable
                      :placeholder="'请输入' + item.fieldCaption"
                    />
                  </dd>
                  <!-- 单选下拉框 -->
                  <dd v-if="item.editorType == 4">
                    <van-cell
                      class="input-item"
                      :value="
                        getDisplayValue(formData[item.field], item)
                          ? getDisplayValue(formData[item.field], item)
                          : '请选择' + item.fieldCaption
                      "
                      is-link
                      @click="showPicker(item, undefined)"
                    />
                  </dd>
                  <!-- 单选下拉框 -->
                  <dd v-if="item.editorType == 5" >
                    <van-cell
                      class="input-item"
                      :value="
                        getDisplayValue(formData[item.field], item)
                          ? getDisplayValue(formData[item.field], item)
                          : '请选择' + item.fieldCaption
                      "
                      is-link
                      @click="showPicker(item, undefined)"
                    />
                  </dd>
                  <!-- 日期选择框 -->
                  <dd v-if="item.editorType === 3">
                    <van-cell
                      class="input-item dateItem"
                      style=""
                      :value="
                        dateFormatString(formData[item.field])
                        ?dateFormatString(formData[item.field])
                        :'请选择' + item.fieldCaption"
                      is-link
                      @click="showDatePicker(undefined, item)"
                    >
                      <template #right-icon>
                        <van-icon name="notes-o" />
                    </template>
                    </van-cell>
                  </dd>
                </dl>
              </template>
            </template>
            <dl>
              <dt>验证码<sup>*</sup></dt>
              <dd>
                <van-field
                  v-model.trim="code"
                  clearable
                  placeholder="请输入验证码"
                ></van-field>

                <div @click="refreshCode" class="vacDiv">
                  <div>
                    <v-sidentify :identifyCode="identifyCode"></v-sidentify>
                  </div>
                  <span>看不清？换一张</span>
                </div>
              </dd>
            </dl>
            <div class="buttonDiv">
              <van-button type="primary" block @click="submit()">提交报名信息</van-button
              >
            </div>
          </div>
          <div class="successBox" v-show="showFlase">
            <van-icon name="checked" />
            <h3>报名成功</h3>
          </div>
          <!-- 选择弹窗 -->
          <van-popup v-model="selectModel" position="bottom">
            <van-datetime-picker
              v-if="dateField"
              :value="dateField.value"
              :min-date="minDate"
              type="date"
              @cancel="onCancel"
              @confirm="onConfirmDate"
            />
            <van-picker
              v-else
              show-toolbar
              ref="picker"
              :value-key="key"
              :columns="columns"
              @change="onChange"
              @cancel="onCancel"
              @confirm="onConfirm"
            />
          </van-popup>
        </div>
        <div class="notice" v-show="type == '2'">
          <dl>
            <dt>会议名称：</dt>
            <dd>{{ meetingDetail.name }}</dd>
          </dl>
          <!--<dl>
            <dt>活动时间：</dt>
            <dd>
              {{ formatDateYMD(meetingDetail.startDate) }} 至
              {{ formatDateYMD(meetingDetail.endDate) }}
            </dd>
          </dl>-->
          <dl>
            <dt>报名时间：</dt>
            <dd>
              {{ formatDateYMD(meetingDetail.registerStartDate) }} 至
              {{ formatDateYMD(meetingDetail.registerEndDate) }}
            </dd>
          </dl>
          <!--<dl>
            <dt>举办地址：</dt>
            <dd>
              {{
                meetingDetail.provinceName
                  ? meetingDetail.provinceName
                  : "待更新"
              }}
              {{ meetingDetail.cityName ? meetingDetail.cityName : "待更新" }}
              {{ meetingDetail.address ? meetingDetail.address : "" }}
            </dd>
          </dl>-->
          <h4>大会简介：</h4>
          <div class="mapBox">
            <div
              class="intrCont"
              v-html="meetingAffairDetail.meetingInfo"
            ></div>
            <div v-if="!meetingAffairDetail.meetingInfo">暂无内容</div>
          </div>
      
          <h4 v-if="meetingAffairDetail.schedule">会议日程：</h4>
          <div class="mapBox" v-if="meetingAffairDetail.schedule">
            <div
              class="intrCont"
               v-html="meetingAffairDetail.schedule ? meetingAffairDetail.schedule.replace('<table', '<table border=1') : ''"
            ></div>
            <div v-if="!meetingAffairDetail.schedule">暂无内容</div>
          </div>


          <h4 v-if="meetingAffairDetail.reportInfo">会议报告：</h4>
          <div class="mapBox" v-if="meetingAffairDetail.reportInfo">
            <div
              class="intrCont"
              v-html="meetingAffairDetail.reportInfo"
            ></div>
            <div v-if="!meetingAffairDetail.reportInfo">暂无内容</div>
          </div>

          <h4 v-if="meetingAffairDetail.contribReq">征文要求：</h4>
          <div class="mapBox" v-if="meetingAffairDetail.contribReq">
            <div
              class="intrCont"
              v-html="meetingAffairDetail.contribReq"
            ></div>
            <div v-if="!meetingAffairDetail.contribReq">暂无内容</div>
          </div>


          <h4 v-if="meetingAffairDetail.exhibitionInfo">会议展览：</h4>
          <div class="mapBox" v-if="meetingAffairDetail.exhibitionInfo">
            <div
              class="intrCont"
              v-html="meetingAffairDetail.exhibitionInfo"
            ></div>
            <div v-if="!meetingAffairDetail.exhibitionInfo">暂无内容</div>
          </div>
          <!-- <h4>资料附件：（点击相关附件即可在线预览）</h4>
          <div>
            为了深入贯彻落实创新驱动发展战略聚焦当前影响林草业高质量发展的重大科技问题，前瞻谋划和布局林草.
          </div> -->
          <h4>
            联系信息：<span v-if="!meetingAffairDetail.contactUs"
              >暂无内容</span
            >
          </h4>
          <div class="mapBox">
            <div v-html="meetingAffairDetail.contactUs" />
          </div>
          <!-- <h4>地图标识：</h4>
          <div class="mapBox">
            <img src="../../assets/images/dtMap.jpg" />
          </div> -->
        </div>
      </div>
      <p class="fontSizeDiv">
        技术支持：智联软件
      </p>
    </div>
  </div>
</template>
<script>
import {
  getMeetingSettings,
  meetingRegisterNoLogin,
  getMeetingDetail,
  getPZUrl,
  getDictionary,
  getHotelsDues,
  singleRegister
} from "@/api/dictionary";
import {
  Icon,
  Row,
  Col,
  Button,
  Swipe,
  SwipeItem,
  DatetimePicker,
  Dialog,
  Field,
  Cell,
  Toast,
  Popup,
  Picker,
} from "vant";
import {
  getSessionStore,
  setSessionStore,
} from "../../utils/sessionStorage.js";
import { mapGetters, mapState, mapActions } from "vuex";
import Sidentify from "../../components/VerificationCode"; //**引入验证码组件**
export default {
  data() {
    return {
      type: "2",
      settingDetail: {},
      formData: {},
      tipContent: "",
      showFlase:false,
      code: null,
      url: "",
      // meetingId: null,
      meetingDetail: {},
      meetingAffairDetail: {},
      identifyCode: "",
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz",
      allDictionary: [],
      pickerField: undefined, // 弹窗选择对应的字段
       dateField: undefined, // 弹窗日期选择的字段,
      selectModel: false,
      columns: [],
      key: "name", //选择弹窗显示对应的参数名
    };
  },
  components: {
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    "v-sidentify": Sidentify,
    [DatetimePicker.name]:DatetimePicker,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  methods: {
    go(path) {
      this.$router.push({ name: path, query: { meetingId: this.meetingId } });
    },
    changeHandle(item) {
        //先判断是不是学生会员
        //再判断学生会员有没有过期
        //1.是 没有过期  取学生会员价格
        //1.是 过期了 学生价
        //2.不是学生会员  学生价
        if (item && item == 1) {
          if (this.userInfo.memberType == 3) {
            let expDate = new Date(this.userInfo.expiryDate);
            let curDate = new Date();
            if (expDate <= curDate) {
              //过期了 学生价
              this.sutdentPrice();
            } else {
              //没有过期取学生会员价格
              let params = {
                meetingId: this.meetingId,
                memberCategory: this.userInfo.memberCategory,
                memberType: this.userInfo.memberType,
              };
              getHotelsDues(params).then((res) => {
                if (res.success) {
                  this.originalPrice = res.result.originalPrice;
                  this.discountPrice = res.result.discountPrice;
                  this.formData.priceTotal = this.discountPrice;
                } else {
                  this.$tips.error("无法获取到报名费用!");
                }
              });
            }
          } else {
            this.sutdentPrice();
          }
          //没有选择是学生
        } else {
          //判断有没有过期
          //1.过期  网员价格
          //2.没有过期  会员价格
          let params = {
            meetingId: this.meetingId,
            memberCategory: this.userInfo.memberCategory,
            memberType: this.userInfo.memberType,
          };
          getHotelsDues(params).then((res) => {
            if (res.success) {
              this.originalPrice = res.result.originalPrice;
              let expDate = new Date(this.userInfo.expiryDate);
              let curDate = new Date();
              if (expDate <= curDate) {
                this.discountPrice = res.result.originalPrice;
              } else {
                this.discountPrice = res.result.discountPrice;
              }
              this.formData.priceTotal = this.discountPrice;
            } else {
              this.$tips.error("无法获取到报名费用!");
            }
          });
        }
    },
    sutdentPrice() {
      let params = {
        meetingId: this.meetingId,
        memberCategory: this.userInfo.memberCategory,
        memberType: this.userInfo.memberType,
        isStudent: 1,
      };
      getHotelsDues(params).then((res) => {
        if (res.success) {
          this.originalPrice = res.result.originalPrice;
          this.discountPrice = res.result.discountPrice;
          this.formData.priceTotal = this.discountPrice;
        } else {
          this.$tips.error("无法获取到报名费用!");
        }
      });
    },
    typeNav(val){
      let memberId = getSessionStore("memberId");
      if(val==1){
        if(!memberId&&memberId==undefined&&!this.meetingDetail.registerType&&this.meetingDetail.registerType!=1){
          this.$router.push({ name: 'meetLogin',query:{registerType:1,meetingId:this.meetingId}})
        }else{
          this.formData.memberId = memberId;
          this.formData.memberCategory=this.userInfo.memberCategory;
          this.formData.memberType= this.userInfo.memberType;
          this.type='1'
        }
      }else{
        this.type='2'
      }
    },
    getPZUrl() {
      let params = {
        id: this.meetingDetail.photoId,
      };
      getPZUrl(params).then((res) => {
        this.url = res.result;
      });
    },
    submit() {
      let valid = this.validateForm();
      if (!valid) {
        return;
      }
      if (this.formData.mobile && this.formData.mobile.length != 11) {
        Toast("请填写正确手机号");
        return;
      }
      if (this.formData.mobile) {
        let reg = new RegExp(/^1[3456789]\d{9}$/);
        let m = reg.test(this.formData.mobile);
        if (!m) {
          Toast("请填写正确手机号");
          return;
        }
      }
      if (!this.code) {
        Toast("验证码不能为空");
        return;
      }
      if (this.code.toLowerCase() !== this.identifyCode.toLowerCase()) {
        Toast("验证码不正确");
        return;
      }
      var dateTime = Date.parse(new Date());
      if (this.meetingDetail.registerStartDate && this.meetingDetail.registerEndDate) {
      var registerStartDate = Date.parse(
        this.meetingDetail.registerStartDate.replace(/-/g, "/")
      );
      var registerEndDate = Date.parse(
        this.meetingDetail.registerEndDate.replace(/-/g, "/")
      );
      if (dateTime > registerEndDate) {
        Toast.fail('报名已结束');
        return;
      }
      if (registerStartDate <= dateTime && dateTime <= registerEndDate) {
        this.formData.meetingId = this.meetingId;
        meetingRegisterNoLogin(this.formData).then((res) => {
          this.tipContent = "";
          if (res.success) {
            content.scrollIntoView()
            this.showFlase= true;
          } else {
            if (res.messageCode == "10010") {
              Toast.fail(res.message);
            } else {
              Toast.fail("报名失败");
            }
          }
        });
      }else{
        Toast.fail('未到报名时间');
      }
    }
    },
    showDatePicker(pickerField, dateField) {
      this.pickerField = pickerField;
      this.dateField = dateField;
      this.selectModel = true;
    },
    onConfirmDate(time) {
      this.dateField.value = time;
      //this.formData[this.dateField.field] = time;
      this.formData[this.dateField.field] = this.dateFormatString(time);
      this.selectModel = false;
    },
    dateFormatString(value,item) {
      if(!value){
        return
      }
      let date = new Date(value);
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      return date.getFullYear() + "-" + m + "-" + d;
    },
    // 重置验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    validateForm() {
      let errFields = [];
      let _this = this;
      this.settingDetail
        .sort((a, b) => a.seq - b.seq)
        .forEach(function(field) {
          if (field.nullable == true || !field.field) {
            return;
          }
          if (!_this.formData[field.field]) {
            errFields.push(field);
            return false;
          }
        });
      let errField = errFields && errFields[0];
      if (errField) {
        Toast(errField.fieldCaption + "不能为空");
        return false;
      }
      return true;
    },
    formatDateYMD(timeStamp) {
        if(timeStamp){
            var date=new Date(timeStamp.replace(/-/g, '/'));
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            return y + ' 年 ' + MM + ' 月 ' + d + ' 日 ';
        }
      //   if (timeStamp) {
      //   let year = new Date(timeStamp).getFullYear();
      //   let month =
      //     new Date(timeStamp).getMonth() + 1 < 10
      //       ? "0" + (new Date(timeStamp).getMonth() + 1)
      //       : new Date(timeStamp).getMonth() + 1;
      //   let date =
      //     new Date(timeStamp).getDate() < 10
      //       ? "0" + new Date(timeStamp).getDate()
      //       : new Date(timeStamp).getDate();
      //   let hh =
      //     new Date(timeStamp).getHours() < 10
      //       ? "0" + new Date(timeStamp).getHours()
      //       : new Date(timeStamp).getHours();
      //   let mm =
      //     new Date(timeStamp).getMinutes() < 10
      //       ? "0" + new Date(timeStamp).getMinutes()
      //       : new Date(timeStamp).getMinutes();
      //   let ss =
      //     new Date(timeStamp).getSeconds() < 10
      //       ? "0" + new Date(timeStamp).getSeconds()
      //       : new Date(timeStamp).getSeconds();
      //   return year + "年" + month + "月" + date +"日";
      // } else {
      //   return "暂无时间";
      // }
    },
    getDisplayValue(value, field) {
      var optionsData = this.fieldDictionary(field.dictionaryId);
      var currentItem = optionsData.find((item) => item.value === value);
      return currentItem ? currentItem.name : "";
    },
    showPicker(pickerField, dateField) {
      this.pickerField = pickerField;
      this.dateField =null;
      this.columns = this.fieldDictionary(pickerField.dictionaryId);
      this.selectModel = true;
    },
    onCancel() {
      this.selectModel = false;
    },
    fieldDictionary(code) {
      return this.allDictionary.filter((item) => item.dictCode == code);
    },
    onConfirm(item) {
      this.selectModel = false;
      var fieldVal;
      this.formData[this.pickerField.field] = fieldVal = item.value;
      if(item.dictCode == 'ISSTUDENT'){
        this.changeHandle(this.formData[this.pickerField.field])
      }
      this.pickerField.value = fieldVal;
      this.pickerField.displayValue = item.name;
      this.pickerField = undefined;
      this.selectKey = undefined;
      
    },
    onChange(picker, values, index) {
      if (this.selectKey === "title") {
        picker.setColumnValues(1, values[0].children);
      } else if (this.selectKey === "jg" || this.selectKey === "province") {
        let city = this.allAddress.filter((item) => {
          return item.parentId === values[0].id;
        });
        if (index === 0) {
          picker.setColumnValues(1, city);
        }
      }
    },
    getData() {
      getMeetingSettings({ meetingId: this.meetingId })
        .then((resp) => {
          if (resp.success) {
            this.settingDetail = resp.result;
          }
        })
        .catch(() => {
          Toast.fail("获取报名设置失败！");
        });
      getMeetingDetail({ meetingId: this.meetingId }).then((res) => {
        if (res.success) {
          this.meetingDetail = res.result.meetingDTO;
          this.$route.meta.title = res.result.meetingDTO.name;
          if (res.result.meetingAffairDTO) {
            this.meetingAffairDetail = res.result.meetingAffairDTO;
            let reg = new RegExp(/style\s*?=\s*?([‘"])[\s\S]*?\1/, "g");
            if (this.meetingAffairDetail.meetingInfo){
              this.meetingAffairDetail.meetingInfo=
              this.meetingAffairDetail.meetingInfo.replace(reg,"");
            }
          }
          if (res.result.meetingDTO.photoId) {
            this.getPZUrl();
          }
        }
      });
    },
  },
  computed: {
    meetingId() {
      return this.$route.query && this.$route.query.meetingId;
    },
    hyType() {
      return this.$route.query && this.$route.query.type;
    },
    minDate() {
      return new Date("1960");
    },
  },
  mounted() {
    // var url = window.location.href; //获取url中"?"符后的字串 ('?modFlag=business&role=1')
    // var url = "http://localhost:8081/#/signupSearch?meetingId=c940d6bb-0be9-4c36-afac-35078866e643";
    // let begin = url.indexOf("?");
    // let a = url.substring(begin, url.length);
    // var theRequest = new Object();
    // if (a.indexOf("?") != -1) {
    //   var str = a.substr(1); //substr()方法返回从参数值开始到结束的字符串；
    //   var strs = str.split("&");
    //   for (var i = 0; i < strs.length; i++) {
    //     theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
    //   }
    //   this.meetingId = theRequest.meetingId;
    //   setSessionStore("meetingId", this.meetingId);
    // }
    var obj = window.localStorage.getItem("userInfo");
    this.userInfo = JSON.parse(obj);
    this.getData();
    // 初始化验证码
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    getDictionary().then((res) => {
      if (res.success) {
        this.allDictionary = res.result;
      }
    });
  },
};
</script>

<style scoped>
.inputkuang{position: relative;}
.intrCont{ line-height: 24px;}
.successBox{ width: 100%; height:350px; background: #fff;
text-align: center; color:#4cb82f }
.successBox i{ font-size: 52px; margin-bottom: 20px; margin-top: 132px;}
</style>
